export default
{
  adblock: 'Bonjour! Ce site joue la transparence et vous donne le choix des services tiers à activer.',
  adblock_call: 'Merci de désactiver votre adblocker pour commencer la personnalisation.',
  reload: 'Recharger la page',

  alertDisclaimerTitle: 'Le respect de votre vie privée est notre priorité',
  alertDisclaimer: 'En poursuivant votre navigation, vous acceptez l\'utilisation par nos partenaires et nous-mêmes de cookies pour proposer des contenus et des offres adaptés à vos centres d\'intérêt, de la publicité personnalisée et analyser notre trafic.',
  alertDisclaimerText: '<p>Lors de votre visite sur ce site, nos partenaires et nous-même pouvons, indépendamment ou conjointement, déposer des cookies et technologies similaires, afin de collecter des informations, y compris des données personnelles, telles que : adresse IP, identifiants uniques, données de navigation, données de géolocalisation.</p><p>Ces données sont traitées par nous même et/ou nos partenaires, dont des partenaires publicitaires, aux fins suivantes : analyser et améliorer l’expérience utilisateur, stocker et/ou accéder à des informations sur un terminal, mesurer et analyser l’audience, interagir avec les réseaux sociaux, lutter contre la fraude, afficher des publicités et contenus personnalisés, mesurer la performance des publicités et du contenu.</p><p>A l’exception de ceux nécessaires au fonctionnement du site ainsi que, sous certaines conditions, à la mesure d’audience, les cookies et technologies similaires ne peuvent être déposés qu’avec votre consentement. Vous pouvez librement donner, refuser ou retirer votre consentement à tout moment en accédant à notre outil de paramétrage des cookies. Si vous ne consentez pas à l’utilisation de ces technologies, nous considérerons que vous vous opposez également à tout dépôt de cookie que certains partenaires justifient par un intérêt légitime.</p>',
  alertBigScroll: 'En continuant de défiler,',
  alertBigClick: 'En poursuivant votre navigation,',
  alertBig: 'vous acceptez l\'utilisation de services tiers pouvant installer des cookies',

  alertBigPrivacy: 'Ce site utilise des cookies et vous donne le contrôle sur ce que vous souhaitez activer',
  alertSmall: 'Gestion des services',
  acceptAll: 'OK, tout accepter',
  personalize: 'Paramétrer',
  close: '&times;',
  closeTitle: 'Fermer la fenêtre',

  privacyUrl: 'Politique de confidentialité',

  all: 'Préférence pour tous les services',

  info: 'Protection de votre vie privée',
  disclaimer: 'En autorisant ces services tiers, vous acceptez le dépôt et la lecture de cookies et l\'utilisation de technologies de suivi nécessaires à leur bon fonctionnement.',
  allow: 'Autoriser',
  deny: 'Interdire',
  noCookie: 'Ce service ne dépose aucun cookie.',
  useCookie: 'Ce service peut déposer jusqu\'à',
  useCookieCurrent: 'Ce service a déposé',
  useNoCookie: 'Ce service n\'a déposé aucun cookie.',
  more: 'En savoir plus',
  source: 'Voir le site officiel',
  credit: 'Gestion des cookies par Nematis',

  toggleInfoBox: 'Afficher/masquer les informations sur le stockage des cookies',
  title: 'Gestion de vos préférences sur les cookies',
  cookieDetail: 'Détail des cookies',
  ourSite: 'sur notre site',
  newWindow: '(nouvelle fenêtre)',
  accept: 'J\'accepte',
  allowAll: 'Autoriser tous les cookies',
  denyAll: 'Continuer sans accepter',

  fallback: 'est désactivé.',

  disabled_content: '%service% est désactivé. Autorisez le dépôt de cookies pour accéder au contenu.',
  disabled_video: '%service% est désactivé. Autorisez le dépôt de cookies pour lire la vidéo.',

  technical: {
    title: 'Cookies techniques',
    details: ''
  },
  ads: {
    title: 'Régies publicitaires',
    details: 'Les régies publicitaires permettent d\'afficher et de mesurer la performance de publicités et contenus personnalisés.'
  },
  analytic: {
    title: 'Mesure d\'audience',
    details: 'Les services de mesure d\'audience permettent de générer des statistiques de fréquentation utiles à l\'amélioration du site.'
  },
  social: {
    title: 'Réseaux sociaux',
    details: 'Les réseaux sociaux permettent d\'améliorer la convivialité du site et aident à sa promotion via les partages.'
  },
  video: {
    title: 'Vidéos',
    details: 'Les services de partage de vidéo permettent d\'enrichir le site de contenu multimédia et augmentent sa visibilité.'
  },
  comment: {
    title: 'Commentaires',
    details: 'Les gestionnaires de commentaires facilitent le dépôt de vos commentaires et luttent contre le spam.'
  },
  support: {
    title: 'Support',
    details: 'Les services de support vous permettent d\'entrer en contact avec l\'équipe du site et d\'aider à son amélioration.'
  },
  api: {
    title: 'APIs',
    details: 'Les APIs permettent de charger des scripts : géolocalisation, moteurs de recherche, traductions, ...'
  },
  other: {
    title: 'Autre',
    details: 'Services visant à afficher du contenu web.'
  }
}
